import 
    {
        useEffect,
        useRef,
        useMemo
    } 
from 'react'
import {
    useDispatch,
    useSelector
} from 'react-redux'

// Constant
import { TEMPLATE } from '../../constants'

// Services
import { wsContainer } from '../../services/websocket'

// Redux Action
import { 
    v3_vehicles, 
} from '../../services/redux/actions'

const {
    PACKAGE
} = TEMPLATE

const {
    WS_PROCESS_PACKAGE
} = PACKAGE

const {
    update_vehicle_info_thru_ws_request,
    update_vehicle_geo_state_thru_ws_request,
    get_batch_vehicle_address_request
} = v3_vehicles

export const WebSocketFunc = () => {

    const dispatch = useDispatch()

        /**
         *  Steps of Front-end Geocoding
         * 
         *  1. Inititalization
         *      -- Call get address's API of all locations
         *      -- Put all locations into prevLocations useRef
         * 
         *  2. Put interval 30-sec get address's API separately from ws; due to differences from 3-sec ws interval
         *      -- Every 30-sec, interval checks whether the updated states is different from stored prevLocations
         *      -- If different latitude from same vehicle found, call get address API then overwrite prevLocations
         */
    
        const init = useRef(true)
        const prevLocations = useRef({})
        const locationsRef = useRef([])
    
        const vehicles = useSelector(state => state.containers.v3.vehicles.stateByID)
        const locations = useMemo(() => {
            return Object.values(vehicles)
                ?.map(vehicle => ({ 
                    vid: vehicle.vid, 
                    location: vehicle.location 
                }))
                ?.filter(vehicle => vehicle.location) || []
        }, [vehicles])

        useEffect(() => {
            locationsRef.current = locations
        }, [locations])
    
        const getAddressessHDLR = (items) => {
            dispatch(get_batch_vehicle_address_request(items.map(({ vid, location }) => ({
                vid,
                lat: location.lat,
                lon: location.lon
            }))))
            
            items.forEach(({ vid, location }) => {
                prevLocations.current = {
                    ...prevLocations.current,
                    [vid]: location
                }
            })
        }
    
        useEffect(() => {
            // geolocation -- vehicle address initialization (1)
            if(init.current && locations.length > 0) {
                getAddressessHDLR(locations)
                init.current = false
            }
        }, [locations])
    
        useEffect(() => {
            // 30-sec interval logic (2)
            const interval = setInterval(() => {
                const currentLocs = locationsRef.current
                if (currentLocs.length > 0) {
                    getAddressessHDLR(currentLocs)
                }
            }, 30000)
    
            return () => clearInterval(interval)
        }, [])
 
    // Websocket
    useEffect(() => {

        wsContainer(
            (err, data) => {

                if(!err) {
                    const {
                        id: refID,
                        mode,
                        item
                    } = data

                    switch(mode) {
                        case WS_PROCESS_PACKAGE.GEO: {
                            const vid = refID

                            vid && dispatch(update_vehicle_geo_state_thru_ws_request(vid, item))

                            break;
                        }
                        case WS_PROCESS_PACKAGE.VHC: {
                            const vid = refID
        
                            vid && dispatch(update_vehicle_info_thru_ws_request(vid, item))

                            break;
                        }

                        default: {
                            break;
                        }
                    }
                }
                
            },
        )


    }, [])
}